module.exports = __webpack_public_path__ + "static/media/Artboard30.37d05bf6.png";